// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabActivitiesSortableTableRow-moduledragHandle__kSykm RequestProfileTabActivitiesDragHandle-moduleRequestProfileTabActivitiesDragHandle__t8gKJ";
var _2 = "RequestProfileTabActivitiesSortableTableRow-modulerowContent__jb99D TaskTableRow-moduleTaskTableRow__hEKeu TableComponent-modulerow__xPAo4";
var _3 = "RequestProfileTabActivitiesSortableTableRow-modulesortableRow__CF68d";
export { _1 as "dragHandle", _2 as "rowContent", _3 as "sortableRow" }
